export default __webpack_public_path__ + "static/media/campaign-1-en.51eceb58.svg";